import getConfig from 'next/config';

import { IRate } from '../interfaces/currencies';
import client from '../utils/client';

interface ICBRatesProps {
  dateFrom?: any;
  dateTo?: any;
  lastTakeCount?: number;
  isoCodes?: string[];
}

export const getCbrfRates = async (params: ICBRatesProps): Promise<IRate[]> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/currencies/cbrfRates/`;
  const { data } = await client.post<IRate[]>(url, params);

  return data;
};
